var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.3408909,8.3031645c-0.3690186-1.3706455-1.449749-2.4513745-2.8204346-2.8203926 c-2.5041084-0.6853433-12.5205441-0.6853433-12.5205441-0.6853433s-10.0163937,0-12.520503,0.6589761 C2.1350904,5.8254228,1.0279944,6.932519,0.658976,8.3031645C0,10.8072729,0,16.000021,0,16.000021s0,5.2190723,0.658976,7.6968136 c0.3690184,1.3706875,1.4497471,2.451376,2.8204334,2.8204346c2.5304353,0.6853027,12.520503,0.6853027,12.520503,0.6853027 s10.0164356,0,12.5205441-0.6589756c1.3706856-0.3690186,2.451416-1.4497471,2.8204346-2.8203945 c0.6589756-2.5041084,0.6589756-7.6968555,0.6589756-7.6968555S32.0261917,10.8072729,31.3408909,8.3031645z  M12.8105011,20.7973404v-9.5946817l8.3294239,4.7973623L12.8105011,20.7973404z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSmall);
export default __webpack_public_path__ + "static/media/youtube--small.86a92bd681372484fab7fb53553d25ff.svg";
export { ForwardRef as ReactComponent };